import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styled from "styled-components";
import ConfirmModal from "../../components/Modal/ConfirmModal";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import { ToastMessage } from "../../components/ToastMessage";
import { CATEGORY } from "../../config/Constants";
import { getFormattedNotificationData } from "../../helper";
import {
  postNotification,
  listNotificationsWithPagination,
  getNotificationDeeplinkType,
} from "../../services/notificationService";
import { PushNotificationFields, Validation } from "./Validation";
import { useLoadContext } from "../../contexts/LoadContext";
import PushNotificationFormContainer from "../../components/PushNotification/PushNotificationFormContainer";
import PushNotificationTable from "../../components/PushNotification/PushNotificationTable";
import { uploadEventImage } from "../../services/eventsService";

const PushNotification = () => {
  const { setLoader } = useLoadContext();
  const [totalNotifications, setTotalNotifications] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const limit = 10;
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openSentModal, setOpenSentModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [error, setError] = useState({
    title: "",
    body: "",
    deepLinkId: "",
  });
  const [responseData, setResponseData] = useState([]);
  const [notificationFormData, setNotificationFormData] = useState({
    body: "",
    title: "",
    category: "",
    imageUrl: "",
    deepLinkId: "",
    shortName: "",
  });
  const [typeList, setTypesList] = useState([]);
  const [typeListraw, setRawTypesList] = useState([]);
  const [enableDL, setIfEnableDL] = useState(false);
  const [notificationSent, setNotificationSent] = useState(false);
  const [isTableDataLoading, setTableDataLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [uploadedImage, setUploadedImage] = useState();

  const uploadImage = (event: any) => {
    let img = new Image();
    img.src = window.URL.createObjectURL(event.target.files[0]);
    img.onload = async () => {
      if (
        event.target.files[0].size > 2048756
        // ||
        // img.width > 672 ||
        // img.height > 378
      ) {
        toast.error(
          <ToastMessage message="Only JPEG or PNG files are allowed." />,
          {
            hideProgressBar: true,
          }
        );
      } else {
        try {
          let { data } = await uploadEventImage(event.target.files[0]);
          setUploadedImage(data.files[0]);
          let formData = { ...notificationFormData };
          let formError = { ...error };
          //@ts-ignore
          formData["imageUrl"] = data.files[0].viewUrl;
          //@ts-ignore
          formError["imageUrl"] = "";
          setNotificationFormData(formData);
          setError(formError);
        } catch (error: any) {
          toast.error(<ToastMessage message="File cannot be uploaded." />, {
            hideProgressBar: true,
          });
        }
      }
    };
  };

  const removeImage = () => {
    let formData = { ...notificationFormData };
    let formError = { ...error };
    //@ts-ignore
    formData["imageUrl"] = "";
    //@ts-ignore
    formError["imageUrl"] = "";
    setNotificationFormData(formData);
    setError(formError);
    setUploadedImage(undefined);
  };

  const handleChange = async (event: any) => {
    if (event.target.name === "imageUrl") {
      uploadImage(event);
    } else if (event.target.name === "category") {
      let formData = { ...notificationFormData };
      let formError = { ...error };
      //@ts-ignore
      formData[event.target.name] = event.target.value;
      //@ts-ignore
      formData["deepLinkId"] = "";
      formData["shortName"] = "";
      //@ts-ignore
      formError[event.target.name] = "";
      setNotificationFormData(formData);
      setError(formError);
      if (event.target.value !== "home") {
        let res = await getNotificationDeeplinkType(event.target.value);
        const transformedData = res?.data?.data.map((item: any) => ({
          value: item._id,
          label: event.target.value === "events" ? item.title : item.name,
        }));

        setTypesList(transformedData);
        setRawTypesList(res?.data?.data);
      } else {
        setIfEnableDL(false);
      }
    } else if (event.target.name === "deepLinkId") {
      let formData = { ...notificationFormData };
      let formError = { ...error };
      //@ts-ignore
      formData[event.target.name] = event.target.value;
      //@ts-ignore
      formError[event.target.name] = "";
      //@ts-ignore
      let selectedShortName = typeListraw.find(
        (item: any) => item._id === event.target.value
        //@ts-ignore
      )?.shortName;
      formData["shortName"] = selectedShortName;
      setNotificationFormData(formData);
      setError(formError);
    } else {
      let formData = { ...notificationFormData };
      let formError = { ...error };
      //@ts-ignore
      formData[event.target.name] = event.target.value;
      //@ts-ignore
      formError[event.target.name] = "";
      setNotificationFormData(formData);
      setError(formError);
    }
  };

  const handleEnableDLChange = (val: boolean) => {
    setIfEnableDL(val);
    // if (!val) {
    let formData = { ...notificationFormData };
    let formError = { ...error };
    //@ts-ignore
    formError["deepLinkId"] = "";
    //@ts-ignore
    formData["deepLinkId"] = "";
    formData["shortName"] = "";
    // }
    setNotificationFormData(formData);
    setError(formError);
  };

  const handleButton = () => {
    let pushNotification: PushNotificationFields = {
      title: notificationFormData.title,
      body: notificationFormData.body,
      deepLinkId: notificationFormData.deepLinkId,
      category: notificationFormData.category,
      enableDL: enableDL,
    };
    const isValid = Validation(pushNotification, setError);

    if (isValid) {
      setOpenConfirmModal(true);
    }
  };

  const handlePushNotification = () => {
    setLoader(true);
    const requestData = {
      body: notificationFormData.body,
      title: notificationFormData.title,
      notificationType:
        notificationFormData.category === ""
          ? "none"
          : notificationFormData.category,
      image: notificationFormData.imageUrl,
      deepLinkId: notificationFormData.deepLinkId,
      shortName: notificationFormData.shortName,
    };
    postNotification(requestData)
      .then((response) => {
        setLoader(false);
        setOpenSentModal(true);
        setOpenConfirmModal(false);
        setNotificationSent(true);
        setNotificationFormData({
          title: "",
          body: "",
          category: "",
          imageUrl: "",
          deepLinkId: "",
          shortName: "",
        });
        setUploadedImage(undefined);
      })
      .catch((error: any) => {
        setLoader(false);
        if (navigator.onLine) {
          setOpenErrorModal(true);
          setErrorMessage(error.message);
        } else {
          toast.error(
            <ToastMessage
              message="You're offline now"
              subMessage="Oops! Internet is disconnected."
            />,
            {
              hideProgressBar: true,
            }
          );
        }
      });
  };

  const fetchPushNotificationList = async () => {
    setTableDataLoading(true);
    try {
      const { data } = await listNotificationsWithPagination(
        currentPage,
        limit
      );
      if (data.code === 200) {
        let formattedNotificationData = getFormattedNotificationData(data.data);
        setTableDataLoading(false);
        setResponseData(formattedNotificationData);
        setTotalNotifications(data.count);
      }
    } catch (error) {
      setTableDataLoading(false);
      if (navigator.onLine) {
        setOpenErrorModal(true);
      }
    }
  };

  useEffect(() => {
    fetchPushNotificationList();
  }, [notificationSent, currentPage]); // eslint-disable-line

  return (
    <div>
      <Header>Push Notification</Header>
      <PushNotificationFormContainer
        onChange={handleChange}
        onRemove={removeImage}
        error={error}
        category={CATEGORY}
        onSubmit={handleButton}
        value={notificationFormData}
        uploadedImage={uploadedImage}
        enableDL={enableDL}
        onEnableDLChange={handleEnableDLChange}
        typeList={typeList}
      />
      {openConfirmModal && (
        <ConfirmModal
          heading="Confirm"
          subHeading="Are you sure you want to send this message?"
          button1Label="Cancel"
          button2Label="Send"
          button1Submit={() => setOpenConfirmModal(false)}
          button2Submit={() => {
            handlePushNotification();
            setOpenConfirmModal(false);
            setNotificationSent(false);
          }}
          setOpenOrClose={setOpenConfirmModal}
        />
      )}
      {openSentModal && (
        <ErrorSuccessModal
          variant="success"
          heading=" Your message was successfully sent."
          buttonLabel="Ok"
          setOpenOrClose={setOpenSentModal}
          onSubmit={() => setOpenSentModal(false)}
        />
      )}
      {openErrorModal && (
        <ErrorSuccessModal
          variant="error"
          heading="Your message could not be sent."
          subHeading={
            errorMessage !== ""
              ? errorMessage
              : "There was some technical issue. Please try after some time."
          }
          buttonLabel="Ok"
          setOpenOrClose={setOpenErrorModal}
          onSubmit={() => {
            setOpenErrorModal(false);
            setErrorMessage("");
          }}
        />
      )}
      <PushNotificationTable
        setCurrentPage={setCurrentPage}
        totalNotifications={totalNotifications}
        currentPage={currentPage}
        limit={limit}
        data={responseData}
        isTableDataLoading={isTableDataLoading}
      />
    </div>
  );
};

const Header = styled.div`
  font-size: 1.25rem;
  font-family: "Poppins-Medium";
  line-height: 1.75rem;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

export default PushNotification;
